import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { nav, topdropdown } from "../data/Data";
import { useSelector } from "react-redux";
import { signOut } from "firebase/auth";
import { auth } from "../config/firebase";
import checkUserSignedIn from "../util/AuthUtil";
import "../css/topbar.css";
import useComponentVisible from "../components/useComponentVisible";

export default function TopBar(props) {
  const [authUser, setAuthUser] = useState(null);
  const [showDropDown, setShowDropDown] = useState(false);
  const { isSticky } = props;
  const { totalItems } = useSelector((state) => state.cart);
  const token = localStorage.getItem("token");
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(showDropDown);

  const navigate = useNavigate();

  useEffect(() => {
    setShowDropDown(isComponentVisible);
  }, [isComponentVisible]);

  useEffect(() => {
    checkUserSignedIn(auth, setAuthUser);
    // if(!authUser)
    //   navigate("/login");
  }, [authUser]);

  const logOut = () => {
    try {
      signOut(auth);
    } catch (err) {
      console.log(err);
    }
    //setProfile(null);
  };
  const profile = () => {
    setShowDropDown(!!!showDropDown);
    setIsComponentVisible(!!!showDropDown);
  };
  const login = () => {
    navigate("/login");
    profile();
  };
  const myOrders = () => {
    navigate("/myorders");
    profile();
  };

  function clearTokenFromStorage() {
    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
    }
  }

  // Renders only the account control now. It used to be a full second header
  // bar (logo + centre logo + profile) stacked above the nav — two headers for
  // one site. Header.js composes this into the single unified bar.
  return (
    <div className="nt-account">
      <div className="profile">
        {/* Inline SVG drawn to the same 1.7 stroke weight as the cart icon.
            person.svg was a heavy filled glyph from a different icon set. */}
        <button
          type="button"
          className="profile-icon"
          onClick={profile}
          aria-label={authUser ? "Your account" : "Sign in"}
          aria-expanded={showDropDown}
          id="profile-icon"
        >
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="8.2" r="3.6" stroke="currentColor" strokeWidth="1.7" />
            <path
              d="M4.8 19.4c.7-3.4 3.6-5.6 7.2-5.6s6.5 2.2 7.2 5.6"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
            />
          </svg>
          {authUser && <span className="nt-account-dot" aria-hidden="true"></span>}
        </button>
        {showDropDown && isComponentVisible && (
          <div
            ref={ref}
            className="dropdown-menu nt-account-menu"
            id="dropdown-menu"
            style={{ display: "block", left: "unset", right: 0 }}
          >
            {authUser && (
              <>
                <a href="#" onClick={myOrders} className="dropdown-item">
                  My Orders
                </a>
                <a onClick={logOut} className="dropdown-item">
                  Logout
                </a>
              </>
            )}
            {!authUser && (
              <a onClick={login} className="dropdown-item">
                Login
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
